import React, { FC, useState } from 'react';
import { Button } from 'antd';
import styles from './styles.module.css';
import { diffChars } from 'diff';

type Props = {
  log: {
    descriptions: string[];
    titles: string[];
  };
};

export const TaskLogDescription: FC<Props> = ({ log }) => {
  const [show, setShow] = useState(false);
  if (!log) return null;

  let previousCopy;
  let currentCopy;

  if (log.titles && log.titles[1] !== null) {
    previousCopy = log.titles[0]?.replace(' (Suggested by AI)', '');
    currentCopy = log.titles[1]?.replace(' (Suggested by AI)', '');
  } else if (log.descriptions && log.descriptions[1] !== null) {
    previousCopy = log.descriptions[0];
    currentCopy = log.descriptions[1];
  }

  if (!currentCopy || !previousCopy) return null;

  const diff = diffChars(previousCopy, currentCopy);

  return (
    <>
      <Button
        type="text"
        size="small"
        onClick={() => setShow(!show)}
        className={styles.changesButton}
      >
        {!show ? 'Show changes' : 'Hide changes'}
      </Button>
      {show && (
        <div className={styles.descriptionDiff}>
          {diff.map((part, index) => {
            let className = '';
            if (part.added) className = styles.diffAdded;
            else if (part.removed) className = styles.diffRemoved;
            return (
              <span key={index} className={className}>
                {part.value}
              </span>
            );
          })}
        </div>
      )}
    </>
  );
};
